export default __webpack_public_path__ + "static/media/after-project.576c8e58.svg";